import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";

import App from "./App";
import { Auth0ProviderWithConfig } from "./auth0-provider-with-config";
import { store } from "./core/store";
import "./styles/index.css";
import "./i18n";
import { ActiveOrgProvider } from "context/ActiveOrgContext";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithConfig>
        <ActiveOrgProvider>
          <Provider store={store}>
            <Toaster position="bottom-right" toastOptions={{ success: { duration: 3000 }, error: { duration: 5000 } }} />
            <App />
          </Provider>
        </ActiveOrgProvider>
      </Auth0ProviderWithConfig>
    </BrowserRouter>
  </React.StrictMode>
);
